export class GraphBatchRequest {
  public id: string;
  public method: string;
  public url: string;
  public body?: { [key: string]: string; };
  public headers?: { [key: string]: string; };

  constructor(opt?: Partial<GraphBatchRequest>) {
    Object.assign(this, opt);
  }
}

export class GraphBatchData {
  public requests: Array<GraphBatchRequest>;
}
